

import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import ClientesSinglePageContainer from '../../components/clients/containers/ClientsSinglePageContainer';
import { getClientsSingleDataIfNeeded } from '../../components/clients/actions/clientsActions';

const ClientesInterna = () => {
    const { slug } = useParams();


    return (
        <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
            <ClientesSinglePageContainer slug={slug} />
        </div>
    );
};

ClientesInterna.fetchData = (store, match) => store.dispatch(getClientsSingleDataIfNeeded(match.params.slug));

ClientesInterna.propTypes = exact({});

export default ClientesInterna;
